(function () {
  'use strict';

  angular
    .module('factories.utils', ['factories.nativeBridge', 'factories.mobileHelper'])
    .factory('Utils', Utils);

  Utils.$inject = ['NativeBridge', '$window', 'MobileHelper', 'Storage', '$rootScope'];

  function Utils(NativeBridge, $window, MobileHelper, Storage, $rootScope) {

    function viewUrl(url) {
      if (!url) return;
      url = url.replace(/&amp;/g, '&');
      if (MobileHelper.isNativeIpadApp)
        return NativeBridge.fireHandler("viewUrl", url);

      try {
        $window.open(url, "_blank");
      } catch (e) {
        // Throws this error in IE for file:// URLs. We can just ignore these.
        if (!!~e.message.indexOf('Access is denied'))
          return;

        throw e;
      }
    }

    function email(url) {
      if (!url) return;
      if (url.indexOf("mailTo") != 0) url = "mailTo:" + url;

      if (MobileHelper.isNativeIpadApp)
        return NativeBridge.fireHandler("mailTo", url);

      $window.location = url;
    }

    function viewUrlInBrowser(url) {
      if (!url) return;
      if (MobileHelper.isNativeIpadApp)
        return NativeBridge.fireHandler("viewUrlInBrowser", url);
      $window.location = url;
    }

    function download(url) {
      if (!url) return;
      if (MobileHelper.isNativeIpadApp)
        return NativeBridge.fireHandler("download", url);
      
      if (MobileHelper.isMobileDevice()) {
        $window.location = url;
        return;
      }

      $window.open(url, '_blank');
    }

    function downloadCertificate(url) {
      if (!url) return;
      if (MobileHelper.isNativeIpadApp)
        return NativeBridge.fireHandler("downloadCertificate", url);

      $window.open(url, '_blank');
    }

    function kissmetrics(event, properties, cb) {
      MobileHelper.getIpadVersion(function (ipadVersion) {
        var user = Storage.getValue('user');
        var selectedAccount = Storage.getValue('selectedAccount');

        if (!$window.mfConfig || !$window.mfConfig.KISSId || !selectedAccount)
          return cb();

        var imgSrc = "//trk.kissmetrics.com/e?_k=" + $window.mfConfig.KISSId
            .concat("&_p=").concat(selectedAccount.userId.toString())
            .concat("&_n=").concat(event)
            .concat("&User ID=").concat(selectedAccount.userId)
            .concat("&User Role=").concat(selectedAccount.role)
            .concat("&Account ID=").concat(selectedAccount.accountId)
            .concat("&Domain=").concat(selectedAccount.portal)
            .concat("&Company Name=").concat(selectedAccount.companyName)
            .concat("&Device=").concat($window.navigator.userAgent)
            .concat("&ipad Version=").concat(ipadVersion)
            .concat("&App=").concat(MobileHelper.isNativeIpadApp ? 'Ipad' : 'Web');

        if (properties) {
          _.each(_.keys(properties), function (key) {
            imgSrc = imgSrc.concat("&").concat(encodeURIComponent(key)).concat("=")
              .concat(encodeURIComponent(properties[key]));
          });
        }

        $('#kmImage').attr('src', imgSrc);

        if (cb) cb();
      });
    }

    // Circular JSON reference fix: https://gist.github.com/jiverson/8604287
    function stringifyOnce(obj) {
      if (typeof obj === 'undefined') return undefined;

      function censor(censor) {
        var i = 0;
        return function (key, value) {
          if (i !== 0 && typeof(censor) === 'object' && typeof(value) == 'object' && censor == value)
            return '[Circular]';

          if (i >= 29) // seems to be a harded maximum of 30 serialized objects?
            return '[Unknown]';

          ++i; // so we know we aren't using the original object anymore
          return value;
        }
      }

      return JSON.stringify(obj, censor(obj));
    }

    // Do not use unless you know why you need to do this and read the full discussion
    // https://groups.google.com/forum/#!topic/angular/FJwxJ-XbJaE/discussion
    function apply(fn, suppress) {
      if (!suppress || !$rootScope.$$phase) {
        $rootScope.$apply(fn);
      } else {
        fn();
      }
    }

    function hideStatusBar(cb) {
      if (MobileHelper.isNativeIpadApp)
        return NativeBridge.fireHandler('hideStatusBar', null, cb);
    }

    function showStatusBar(cb) {
      if (MobileHelper.isNativeIpadApp)
        return NativeBridge.fireHandler('showStatusBar', null, cb);
    }

    return {
      viewUrl: viewUrl,
      email: email,
      viewUrlInBrowser: viewUrlInBrowser,
      download: download,
      downloadCertificate: downloadCertificate,
      kissmetrics: kissmetrics,
      apply: apply,
      stringifyOnce: stringifyOnce,
      hideStatusBar: hideStatusBar,
      showStatusBar: showStatusBar
    };
  }

})();
